// removed by extract-text-webpack-plugin
module.exports = {"svg-icon":"svg-icon_svg-icon--2Q9UGEhA","svgIcon":"svg-icon_svg-icon--2Q9UGEhA"};


//////////////////
// WEBPACK FOOTER
// ./components/svg-icon/src/styles/svg-icon.scss
// module id = 1579
// module chunks = 0